import { render, staticRenderFns } from "./pluginsTopNav.vue?vue&type=template&id=13c45dff&scoped=true"
import script from "./pluginsTopNav.vue?vue&type=script&lang=js"
export * from "./pluginsTopNav.vue?vue&type=script&lang=js"
import style0 from "./pluginsTopNav.vue?vue&type=style&index=0&id=13c45dff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c45dff",
  null
  
)

export default component.exports